// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router';
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
import echarts from "echarts";
Vue.prototype.$echarts = echarts;
import ElementUI from 'element-ui'
import VueClipboard from 'vue-clipboard2'
import 'element-ui/lib/theme-chalk/index.css'
//公用函数
import common from './components/js/axios.js';
Vue.use(VueClipboard)
Vue.use(ElementUI)
for (var key in common)
{
	window[key] = common[key];
};

Vue.config.productionTip = false
// 路由守卫
router.beforeEach((to,from,next)=>{
  if (localStorage.getItem('userId')) {
    next();
}else{
    next(-1);
}
})

//base64解码
let Base64 = require('js-base64').Base64;
Vue.filter(('wxNickName'), function (wxNickName) {
  return Base64.decode(wxNickName)
});

/* eslint-disable no-new */
new Vue
({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js